import { motion } from 'framer-motion';
import { ChevronRight, ChevronDown, ArrowRight, CheckCircle2 } from 'lucide-react';
import PortalShellV2 from '@/components/PortalShellV2';

export default function ReportSubmittedV2Scene() {
  return (
    <PortalShellV2 variant="headerOnly">
      <div data-testid="scene-report-submitted-v2" className="px-16 pt-8 pb-10">
        <div className="max-w-5xl mx-auto relative">

          {/* Success toast (centered, refs image 6) */}
          <motion.div
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            className="absolute top-[-28px] left-1/2 -translate-x-1/2 z-10 px-4 py-2.5 rounded-lg bg-emerald-50 border border-emerald-200 flex items-center gap-2 shadow-sm"
          >
            <CheckCircle2 size={16} className="text-emerald-600" />
            <p className="text-[13px] font-body text-emerald-800 font-medium">Your issue is being processed</p>
          </motion.div>

          <div className="text-[12.5px] font-body text-[#6B7280] mb-2 flex items-center gap-1">
            Home <ChevronRight size={11} /> <span className="text-[#0A0A0A]">Report Issue</span>
          </div>

          <h1 className="font-heading font-extrabold text-[42px] leading-tight tracking-tight text-[#0A0A0A] mb-2">
            Report Issue
          </h1>
          <div className="border-b border-[#E5E7EB] mb-8" />

          <section className="opacity-80">
            <h2 className="font-heading font-extrabold text-[22px] text-[#0A0A0A] mb-5">Basic details</h2>

            <div className="grid grid-cols-2 gap-x-8 gap-y-5 mb-8">
              <div>
                <label className="text-[13px] font-body text-[#0A0A0A] mb-1.5 block">Name</label>
                <div className="w-full px-3.5 py-2.5 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-[13px] font-body text-[#0A0A0A] min-h-[42px] flex items-center">Abdul Ahmed</div>
              </div>
              <div>
                <label className="text-[13px] font-body text-[#0A0A0A] mb-1.5 block">Email address</label>
                <div className="w-full px-3.5 py-2.5 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-[13px] font-body text-[#0A0A0A] min-h-[42px] flex items-center">abdulahmed@abc.com</div>
              </div>
              <div>
                <label className="text-[13px] font-body text-[#0A0A0A] mb-1.5 block">Module</label>
                <div className="w-full px-3.5 py-2.5 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-[13px] font-body text-[#9CA3AF] min-h-[42px] flex items-center justify-between">
                  <span>Select module</span>
                  <ChevronDown size={15} className="text-[#6B7280]" />
                </div>
              </div>
              <div />
            </div>

            <div className="border-t border-[#E5E7EB] mb-8" />

            <h2 className="font-heading font-extrabold text-[22px] text-[#0A0A0A] mb-5">Complaint</h2>
            <div className="grid grid-cols-2 gap-x-8 gap-y-5 mb-5">
              <div>
                <label className="text-[13px] font-body text-[#0A0A0A] mb-1.5 block">Subject<span className="text-red-500">*</span></label>
                <div className="w-full px-3.5 py-2.5 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-[13px] font-body text-[#0A0A0A] min-h-[42px] flex items-center">Lorem ipsum</div>
              </div>
              <div>
                <label className="text-[13px] font-body text-[#0A0A0A] mb-1.5 block">File</label>
                <div className="flex gap-2">
                  <div className="flex-1 px-3.5 py-2.5 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-[13px] font-body min-h-[42px] flex items-center">xyz.pdf</div>
                  <button className="px-4 py-2.5 rounded-lg border border-[#E5E7EB] text-[13px] font-body text-[#374151] bg-[#FAFAFA]">Upload</button>
                </div>
              </div>
            </div>

            <div className="mb-6">
              <label className="text-[13px] font-body text-[#0A0A0A] mb-1.5 block">Description<span className="text-red-500">*</span></label>
              <div className="w-full px-3.5 py-3 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-[13px] font-body text-[#0A0A0A] min-h-[100px] leading-relaxed">
                Lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum.
              </div>
              <p className="text-[11px] font-body text-[#9CA3AF] mt-1">Max 1,000 characters</p>
            </div>
          </section>

          <div className="flex justify-center">
            <button className="flex items-center gap-2 px-12 py-3 rounded-xl bg-teal-600/50 text-white font-body font-bold text-[13px] cursor-default">
              Submit <ArrowRight size={15} />
            </button>
          </div>
        </div>
      </div>
    </PortalShellV2>
  );
}
